"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function compose() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    if (funcs.length === 0) {
        throw new Error('Cannot compose without any ProppyJS factories');
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return function (providers, parent) {
        if (providers === void 0) { providers = {}; }
        if (parent === void 0) { parent = null; }
        var f = funcs[0](providers, parent);
        for (var i = 1; i < funcs.length; i++) {
            f = funcs[i](providers, f);
        }
        return f;
    };
}
exports.compose = compose;
//# sourceMappingURL=compose.js.map